module.exports = __webpack_public_path__ + "img/logo-white.4e6dc8cb.svg";